import {
  SkeletonLoader,
  Table,
  TableCell,
  TableHeaderCell,
  TableRow,
  TableWrapper,
} from '@unified-checkout/design-system';

import type { ITableInfoProps } from '@app/dashboard/types/innerLayout/table-info';

import { ComponentError } from '../../shared/ComponentError';

import styles from './TableInfo.module.scss';

const ONE_COLUMN = 1;

const TableInfo = ({
  columns,
  data = [],
  componentErrorText,
  disabled,
  maxHeight,
  isLoading,
  skeltonProps,
}: ITableInfoProps) => {
  const numOfColumns = columns.length;
  const hasData = !!data?.length;

  return (
    <TableWrapper disabled={disabled} wrapperClassName={styles['table-info']}>
      {isLoading ? (
        <div className={styles['table-info__skeleton-loader']}>
          <SkeletonLoader {...skeltonProps} />
        </div>
      ) : (
        <Table maxHeight={maxHeight}>
          <TableRow>
            {columns.slice(0, !hasData ? ONE_COLUMN : numOfColumns).map((columnName) => (
              <TableHeaderCell key={columnName.id} text={columnName.name} />
            ))}
          </TableRow>

          {!data?.length ? (
            <div className={styles['table-info__no-results']}>
              <ComponentError text={componentErrorText} />
            </div>
          ) : (
            data?.map((row: Record<string, any>, rowIndex: number) => (
              <TableRow key={`row-${rowIndex}`}>
                {columns.map((item, cellIndex) => {
                  if (!!item.render) {
                    const { select, render } = item;
                    const data = select(row);

                    return (
                      <TableCell
                        key={`table-body-${item.id}-custom`}
                        width={item.width}
                        type="custom"
                        customContent={render(data, row, cellIndex)}
                        {...item}
                      />
                    );
                  }
                })}
              </TableRow>
            ))
          )}
        </Table>
      )}
    </TableWrapper>
  );
};

export default TableInfo;
